import React from 'react';
import { useSharableSeriesId } from '@/hooks';
import ErrorBoundary from '@/components/ErrorBoundary';
import ShareHtml_LEGACY from '@/containers/ShareHtml';

const SharedSavedQuery = () => {
  const sharableSeriesId = useSharableSeriesId();

  return (
    <ErrorBoundary>
      <ShareHtml_LEGACY sharedView={sharableSeriesId} />
    </ErrorBoundary>
  );
};

export default SharedSavedQuery;
